import React, { useState } from "react";

interface Props {
  onAdd: (item: { name: string; price: number; taxable: boolean }) => void;
  onClose: () => void;
}

export default function CustomItemModal({ onAdd, onClose }: Props) {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [taxable, setTaxable] = useState(true);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !price) return;
    onAdd({ name: name.trim(), price: parseFloat(price), taxable });
    onClose();
  };

  // Touch keypad for price entry
  const appendDigit = (d: string) => {
    if (d === "." && price.includes(".")) return;
    setPrice((prev) => prev + d);
  };
  const clearPrice = () => setPrice("");
  const backspace = () => setPrice((prev) => prev.slice(0, -1));

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "380px" }}>
        <h3 style={{ marginBottom: "1rem" }}>Custom Item</h3>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "1rem" }}>
            <label style={{ display: "block", fontSize: "0.825rem", fontWeight: 500, marginBottom: "0.3rem" }}>Item Name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Miscellaneous item"
              required
              style={{ width: "100%", padding: "0.6rem 0.8rem", border: "1px solid #d1d5db", borderRadius: "6px", fontSize: "0.95rem" }}
              autoFocus
            />
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label style={{ display: "block", fontSize: "0.825rem", fontWeight: 500, marginBottom: "0.3rem" }}>Price</label>
            <div style={{ background: "#f9fafb", border: "1px solid #d1d5db", borderRadius: "6px", padding: "0.75rem", textAlign: "right", fontSize: "1.5rem", fontFamily: "monospace", fontWeight: 700, marginBottom: "0.5rem" }}>
              ${price || "0.00"}
            </div>

            {/* Touch Keypad */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "0.4rem" }}>
              {["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "⌫"].map((key) => (
                <button
                  key={key}
                  type="button"
                  onClick={() => key === "⌫" ? backspace() : appendDigit(key)}
                  style={{ padding: "0.75rem", fontSize: "1.1rem", border: "1px solid #e5e7eb", borderRadius: "6px", background: "white", cursor: "pointer", fontWeight: 500 }}
                >
                  {key}
                </button>
              ))}
            </div>
            <button type="button" onClick={clearPrice} style={{ width: "100%", marginTop: "0.4rem", padding: "0.5rem", fontSize: "0.85rem", border: "1px solid #e5e7eb", borderRadius: "6px", background: "#f9fafb", cursor: "pointer" }}>
              Clear
            </button>
          </div>

          <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1.25rem", cursor: "pointer" }}>
            <input type="checkbox" checked={taxable} onChange={(e) => setTaxable(e.target.checked)} />
            <span style={{ fontSize: "0.9rem" }}>Taxable</span>
          </label>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary" style={{ width: "auto" }} disabled={!name.trim() || !price}>
              Add to Cart
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
